export default "__VITE_ASSET__dvhaz4UR__"